import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Checkbox } from 'antd';

const LoginForm = ({ email, password, handleChange, handleSubmit, apiResponse, loading }) => {
  const [toggle, setToggle] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleToggle = (e) => {
    setToggle((prev) => !prev);
  };

  return (
    <div className='login-form-card'>
      <div className='card-header'>
        <h2>Bem-vindo(a)</h2>
      </div>
      <div className='card-body'>
        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label className='form-label'>Email</label>
            <input
              onChange={handleChange('email')}
              type='email'
              className='form-control'
              placeholder='seu.email@exemplo.com'
              value={email}
            />
          </div>

          <div className='form-group'>
            <label className='form-label'>Senha</label>
            <div className='password-wrapper'>
              <input
                onChange={handleChange('password')}
                type={toggle ? 'text' : 'password'}
                className='form-control'
                placeholder='••••••••'
                value={password}
                id='password'
              />
              {toggle ? (
                <i className='fas fa-eye togglePassword' onClick={handleToggle}></i>
              ) : (
                <i
                  className='fas fa-eye-slash togglePassword'
                  onClick={handleToggle}
                ></i>
              )}
            </div>
            {apiResponse && (
              <small className='text-danger mt-1 d-block'>{apiResponse}</small>
            )}
          </div>

          <div className='remember-forgot-container'>
            <Checkbox
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            >
              Lembrar-me
            </Checkbox>
            <Link to='/forgot-password' className='text-decoration-none'>
              Esqueceu a senha?
            </Link>
          </div>

          <Button
            type='primary'
            size='large'
            htmlType='submit'
            disabled={loading}
          >
            {loading ? 'Carregando...' : 'Entrar'}
          </Button>

          {process.env.REACT_APP_ENABLE_USER_REGISTRATION === 'true' && (
            <div className='register-link-container'>
              <p>
                Ainda não tem uma conta?
                <Link to='/register' className='text-decoration-none'>
                  Crie uma agora!
                </Link>
              </p>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
